import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  clients: null,
  projects: null,
  labs: null,
};

const FilterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    fetchClients: (state, action) => {
      state.loading = true;
      state.clients = null;
    },
    fetchClientsSuccess: (state, action) => {
      state.loading = false;
      state.clients = action.payload?.data?.document;
    },
    fetchClientsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "Failed to fetch clients";
    },
    fetchProjects: (state, action) => {
      state.loading = true;
      state.projects = null;
    },
    fetchProjectsSuccess: (state, action) => {
      state.loading = false;
      state.projects = action.payload?.data;
    },
    fetchProjectsFailure: (state, action) => {
      state.loading = false;
      state.projects = action.payload;
    },
    fetchLabs: (state, action) => {
      state.loading = true;
      state.labs = null;
    },
    fetchLabsSuccess: (state, action) => {
      state.loading = false;
      state.labs = action.payload?.data?.document;
    },
    fetchLabsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "Failed to fetch labs";
    },
  },
});

export const { actions, reducer, name: sliceKey } = FilterSlice;
